import { render, staticRenderFns } from "./DialogsComponent.vue?vue&type=template&id=3d3d4042&scoped=true"
import script from "./DialogsComponent.vue?vue&type=script&lang=js"
export * from "./DialogsComponent.vue?vue&type=script&lang=js"
import style0 from "./DialogsComponent.vue?vue&type=style&index=0&id=3d3d4042&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3d4042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d3d4042')) {
      api.createRecord('3d3d4042', component.options)
    } else {
      api.reload('3d3d4042', component.options)
    }
    module.hot.accept("./DialogsComponent.vue?vue&type=template&id=3d3d4042&scoped=true", function () {
      api.rerender('3d3d4042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogsComponent.vue"
export default component.exports